export const FeatureAnimationTheme = {
  light: {
    background: 'bg-warm-neutral-100',
    header: 'text-primary',
    text: 'text-on-primary-surface',
    pictogramType: 'brand',
    pagination: 'text-teal',
    underline: 'bg-primary'
  },
  piggybank: {
    background: (invertColors: boolean) =>
      invertColors ? 'bg-accent5-weakest' : 'bg-accent5-strongest',
    header: (invertColors: boolean) =>
      invertColors ? 'text-accent5-strongest' : 'text-piggybank-400',
    pagination: (invertColors: boolean) =>
      invertColors ? 'text-accent5-strongest' : 'text-piggybank-400',
    underline: (invertColors: boolean) =>
      invertColors ? 'bg-accent5-strongest' : 'bg-piggybank-400',
    text: (invertColors: boolean) =>
      invertColors ? 'text-on-screen-surface' : 'text-on-screen-surface-dark',
    pictogramType: 'accent-5'
  },
  lagoon: {
    background: (invertColors: boolean) =>
      invertColors ? 'bg-accent2-weakest' : 'bg-accent2-strongest',
    header: (invertColors: boolean) =>
      invertColors ? 'text-accent2-strongest' : 'text-accent2-base',
    pagination: (invertColors: boolean) =>
      invertColors ? 'text-accent2-strongest' : 'text-accent2-base',
    underline: (invertColors: boolean) =>
      invertColors ? 'bg-accent2-strongest' : 'bg-accent2-base',
    text: (invertColors: boolean) =>
      invertColors ? 'text-on-screen-surface' : 'text-on-screen-surface-dark',
    pictogramType: 'accent-2'
  },
  grape: {
    background: (invertColors: boolean) =>
      invertColors ? 'bg-accent1-weakest' : 'bg-accent1-strongest',
    header: (invertColors: boolean) =>
      invertColors ? 'text-accent1-strongest' : 'text-accent1-base',
    pagination: (invertColors: boolean) =>
      invertColors ? 'text-accent1-strongest' : 'text-accent1-base',
    underline: (invertColors: boolean) =>
      invertColors ? 'bg-accent1-strongest' : 'bg-accent1-base',
    text: (invertColors: boolean) =>
      invertColors ? 'text-on-screen-surface' : 'text-on-screen-surface-dark',
    pictogramType: 'accent-1'
  },
  tangerine: {
    background: (invertColors: boolean) =>
      invertColors ? 'bg-accent4-weakest' : 'bg-accent4-strongest',
    header: (invertColors: boolean) =>
      invertColors ? 'text-accent4-strongest' : 'text-accent4-base',
    pagination: (invertColors: boolean) =>
      invertColors ? 'text-accent4-strongest' : 'text-accent4-base',
    underline: (invertColors: boolean) =>
      invertColors ? 'bg-accent4-strongest' : 'bg-accent4-base',
    text: (invertColors: boolean) =>
      invertColors ? 'text-on-screen-surface' : 'text-on-screen-surface-dark',
    pictogramType: 'accent-4'
  },
  lime: {
    background: (invertColors: boolean) =>
      invertColors ? 'bg-accent3-weakest' : 'bg-accent3-strongest',
    header: (invertColors: boolean) =>
      invertColors ? 'text-accent3-strongest' : 'text-accent3-base',
    pagination: (invertColors: boolean) =>
      invertColors ? 'text-accent3-strongest' : 'text-accent3-base',
    underline: (invertColors: boolean) =>
      invertColors ? 'bg-accent3-strongest' : 'bg-accent3-base',
    text: (invertColors: boolean) =>
      invertColors ? 'text-on-screen-surface' : 'text-on-screen-surface-dark',
    pictogramType: 'accent-3'
  },
  brand: {
    background: (invertColors: boolean) =>
      invertColors ? 'bg-brand-weakest' : 'bg-brand-strongest',
    header: (invertColors: boolean) =>
      invertColors ? 'text-brand-strongest' : 'text-brand-base',
    pagination: (invertColors: boolean) =>
      invertColors ? 'text-brand-strongest' : 'text-brand-base',
    underline: (invertColors: boolean) =>
      invertColors ? 'bg-brand-strongest' : 'bg-brand-base',
    text: (invertColors: boolean) =>
      invertColors ? 'text-on-screen-surface' : 'text-on-screen-surface-dark',
    pictogramType: 'brand'
  }
} as const;

export type ColorTheme = keyof typeof FeatureAnimationTheme;

export const getThemeClasses = (colorTheme: string, invertColors: boolean) => {
  const themeKey = Object.prototype.hasOwnProperty.call(
    FeatureAnimationTheme,
    colorTheme as PropertyKey
  )
    ? (colorTheme as ColorTheme)
    : 'light';

  const theme = FeatureAnimationTheme[themeKey];

  return {
    background:
      typeof theme.background === 'function'
        ? theme.background(invertColors)
        : theme.background,
    header:
      typeof theme.header === 'function'
        ? theme.header(invertColors)
        : theme.header,
    underline:
      typeof theme.underline === 'function'
        ? theme.underline(invertColors)
        : theme.underline,
    text:
      typeof theme.text === 'function' ? theme.text(invertColors) : theme.text,
    pagination:
      typeof theme.pagination === 'function'
        ? theme.pagination(invertColors)
        : theme.pagination,
    pictogramType: theme.pictogramType
  };
};
